import {Form, FormControl} from '@angular/forms';
import {EventEmitter, Input, Output} from '@angular/core';
import {TYPE_VALUE_FORM} from '../../models/type-value-form.enum';
import {TYPE} from '../../models/type.enum';
import {InBaseFrwComponent} from '../inBaseFrwComponent';

export class InputBase extends InBaseFrwComponent {
  nameId = '';
  @Input() control: FormControl;
  @Input() name;
  @Input() _placeholder = '';
  @Input() _maxlenght: any;
  @Input() icon = '';
  @Input() model: any;
  @Input() _minlength: any;
  @Input() _type: TYPE_VALUE_FORM = TYPE_VALUE_FORM.TEXT;
  @Input() onClass = '';
  @Input() isDisabled = false;
  @Input() _label = '';
  @Input() textDetail = '';
  @Input() colorTextDetail: TYPE = TYPE.DANGER;
  @Input() viewTextDetail = true;
  @Input() messageInvalidField = false;
  @Output() modelChange = new EventEmitter();
  @Output() controlChange = new EventEmitter();
  @Output() clickAction = new EventEmitter();

  constructor() {
    super();
    this.nameId = this.getNameId();
  }

  getNameId() {
    return `input_${this.id_crazy}`;
  }


  outputModel() {
    if (this.control) {
      this.controlChange.emit(this.control);
    } else {
      this.modelChange.emit(this.model);
    }
  }


  get viewMesageDinamicValidation() {
    return this.messageInvalidField
      && (this.control && !this.control.valid && (this.control.dirty || this.control.touched));
  }

  get classCustom() {
    let retorno = 'form-control form-control-sm ';
    if (this.onClass) {
      retorno += this.onClass;
    }
    return retorno;
  }
}

